module.exports = __webpack_public_path__ + "static/icon_bg-b11688deeaa0408e862d9f733e1e3ccf.png";